'use strict'
function navigationServiceFactory($rootScope, $location,
        BreedListService, EntryIDService, TranslationService, UtilityService, DisorderDataService,
        reportdata) {

    'ngInject';

    var navList = [];
    var resultString = reportdata.resultString;

    var atRiskData=DisorderDataService.getAtRiskData();
    var carrierData=DisorderDataService.getCarrierData();
    var noCallData=DisorderDataService.getNoCallData();
    var allClearData=DisorderDataService.getAllClearData();

    var buildNavigationList = function() {

        navList.push({
            "url": "/",
            "text": "Home"
        });
        navList.push({
            "url": "/ancestry/" + EntryIDService.getEntryID("Ancestry"),
            "text": "Start: Ancestry"
        });
        navList.push({
            "url": "/ancestrytree/" + EntryIDService.getEntryID("Ancestry Tree"),
            "text": "Next: Ancestry Tree"
        });

        // TODO need to check for version, also
        if (resultString.resultPbDd && resultString.resultPbDd.length > 0) { 
            navList.push({
                "url": "/breedtests/" + EntryIDService.getEntryID("Breed Tests"),
                "text": "Next: Breed Tests"
            });
        }

        var breedList = BreedListService.getSortedBreedList();

        for (var i = 0; i < breedList.length; ++i) {
            if (breedList[i]['breed'] == 'Mixed Breed Groups') {
                navList.push({
                    "url": "/mixedbreedgroups/" + EntryIDService.getEntryID("Mixed Breed Groups"),
                    "text": "Next: Mixed Breed Groups"
                });
            } else if (breedList[i]['count'] > 0) {
                navList.push({
                    "url": "/breed/" + EntryIDService.getEntryID(breedList[i]['breed']),
                    "text": "Next: Breed"
                });
            }
        }

        var productVersion = UtilityService.getProductVersion();
        
        if (UtilityService.getVersionFeature('Breeds Analyzed')) {
            navList.push({
                "url": "/breedsanalyzed/" + EntryIDService.getEntryID("Breeds Analyzed"),
                "text": "Next: Breeds Analyzed"
            });
        }

        navList.push({
            "url": "/certificate/" + EntryIDService.getEntryID("Certificate"),
            "text": "Next: Certificate"
        });
        navList.push({
            "url": "/health/" + EntryIDService.getEntryID("Health"),
            "text": "Next: Health"
        });
        if (UtilityService.getVersionFeature('WisdomHealth')) {
            if(atRiskData.length>0){
                navList.push({
                    "url": "/atrisk/" + EntryIDService.getEntryID('At Risk'),
                    "text": "Next: At Risk"
                });
            }
    
            if(carrierData.length>0){
                navList.push({
                  "url": "/carrier/" + EntryIDService.getEntryID('Carrier'),
                  "text": "Next: Carrier"
                });
            }
            if(allClearData.length>0){
                navList.push({
                    "url": "/allclear/" + EntryIDService.getEntryID('All Clear'),
                    "text": "Next: All Clear"
                });
            }
            if(noCallData.length>0){
                navList.push({
                    "url": "/nocall/" + EntryIDService.getEntryID('No Call'),
                    "text": "Next: No Call"
                });
            }
        }
        if (UtilityService.getVersionFeature('MDR1')) {
            navList.push({
                "url": "/multidrugsensitivity/" + EntryIDService.getEntryID("Multidrug Sensitivity"),
                "text": "Next: Multidrug Sensitivity"
            });
        }
        if (UtilityService.getVersionFeature('EIC')) {
            navList.push({
                "url": "/eic/" + EntryIDService.getEntryID("Exercise Induced Collapse"),
                "text": "Next: Exercise Induced Collapse"
            });
        }
        navList.push({
            "url": "/adultweight/" + EntryIDService.getEntryID("Adult Weight"),
            "text": "Next: Adult Weight"
        });
        if (UtilityService.getVersionFeature('Traits')) {
            navList.push({
                "url": "/traits/" + EntryIDService.getEntryID("Traits"),
                "text": "Next: Traits"
            });
        }
        navList.push({
            "url": "/notes/" + EntryIDService.getEntryID("Notes"),
            "text": "Next: Notes"
        });

        return navList;
    };

    var getNext = function(location) {

        for (var i = 0; i < navList.length; ++i) {
            if (location == navList[i]['url'] && i < navList.length - 1) {
                return navList[i + 1];
            }
        }
        return {
            "url": "",
            "text": ""
        };
    };

    var getPrev = function(location) {

        for (var i = navList.length - 1; i >= 0; --i) {
            if (location == navList[i]['url'] && i > 0) {

                return navList[i - 1];
            }
        }

        return {
            "url": "",
            "text": ""
        };
    };

    return {
        getPrev: getPrev,
        getNext: getNext,
        buildNavigationList: buildNavigationList,
        setNavigationUrls: function() {

            if (navList.length == 0) {
                navList = buildNavigationList();
            }
            var location = $location.url();
            var next = getNext(location);
            $rootScope.forwardUrl = next['url'].length > 0 ? next['url'].substring(1) : "";
            $rootScope.forwardText = next['url'].length > 0 ? TranslationService.getTranslation(next['text']) : "";

            var prev = getPrev(location);
            $rootScope.backwardUrl = prev['url'].length > 0 ? prev['url'].substring(1) : "";
            $rootScope.backwardText = prev['url'].length > 0 ? TranslationService.getTranslation("Back") : "";
        }
    };
}

export default angular.module('mars.vet.services.navigation',[]).factory('NavigationService', navigationServiceFactory).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/services/navigation.service.js